import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { linkify } from '../utils/linkify';
export function CellPopup({ x, y, title, text, onClose }) {
    return (_jsxs("div", { "data-cellpop-keep": "1", "data-menu-keep": "1", "data-seg-keep": "1", style: {
            position: 'fixed',
            left: x,
            top: y,
            zIndex: 60,
            width: 420,
            maxWidth: '92vw',
            background: '#FFFFFF',
            border: '1px solid #E2E8F0',
            borderRadius: 12,
            boxShadow: '0 12px 32px rgba(15,23,42,.22)',
            padding: 14,
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
        }, children: [_jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 8 }, children: [_jsx("span", { style: { fontSize: 12, fontWeight: 700, color: '#334155', flex: 1 }, children: title }), _jsx("button", { type: "button", onClick: onClose, style: {
                            border: 'none',
                            background: 'none',
                            cursor: 'pointer',
                            fontSize: 14,
                            color: '#64748B',
                            padding: 4,
                            lineHeight: 1,
                        }, "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C", children: "\u2715" })] }), _jsx("div", { style: {
                    fontSize: 12.5,
                    lineHeight: 1.5,
                    color: '#0F172A',
                    maxHeight: 300,
                    overflow: 'auto',
                    overflowWrap: 'anywhere',
                    whiteSpace: 'pre-wrap',
                }, children: linkify(text, 360) })] }));
}
